import { RouterStore } from 'mobx-react-router';
import { action } from "mobx";
import AjaxService from 'Services/ajax-service'
import { onRequestConfig, onRequestConfigError, onResponse, onResponseError, onNoServerResponse, onResponseDownload } from 'Services/network-config'
import { UserInfoStore } from '@sogei/agenzia-entrate-common'
//import UserInfoStore  from './user-store'
import MenuStore from './menu-store'
import ErrorStore from './error-store'
import UiStore from './ui-store';
import LeftMenuStore from './left-menu-store'
import TipologicaStore from './tipologica-store'
import RicevuteStore from './ricevute-store';
import TrasmissioneStore from './trasmissione-store';
import QualificheStore from './qualifiche-store';
import RicevuteDuploStore from './ricevute-duplo-store';
import RichiestaDuploStore from './richiesta-duplo-store';
import UtenteStore from './utente-store';
import FermoStore from './fermo-store';

 
class RootStore {
  constructor() {
    this.service = new AjaxService(this, onRequestConfig, onRequestConfigError, onResponse, onResponseError, onNoServerResponse)
    this.serviceDownload = new AjaxService(this, onRequestConfig, onRequestConfigError, onResponseDownload, onResponseError, onNoServerResponse)
    this.uiStore = new UiStore(this)
    this.routingStore = new RouterStore();
    this.userInfoStore = new UserInfoStore(this)
    this.menuStore = new MenuStore(this)
    this.errorStore = new ErrorStore(this)
    this.leftMenuStore = new LeftMenuStore(this)
    this.tipologicaStore = new TipologicaStore(this);
    this.qualificheStore = new QualificheStore(this);
    this.ricevuteStore = new RicevuteStore(this);
    this.trasmissioneStore = new TrasmissioneStore(this);
    this.fermoStore = new FermoStore(this);
    this.ricevuteDuploStore = new RicevuteDuploStore(this);
    this.richiestaDuploStore = new RichiestaDuploStore(this);
    this.utenteStore = new UtenteStore(this);

 
  }

  @action
  refreshStore() {
   // console.log('refresh stores ....')
    let stores = Object.keys(this).filter(props => props !== 'service' || props !== 'cambiaUtenzaStore' || props !== 'routingStore')
    for (let store of stores) {
      this[store].fetched = false
    }
  }
}

export default RootStore;